<mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="tabChanged($event)">
  <!-- Proposer Tab -->
  <mat-tab>
    <ng-template mat-tab-label>
      Proposer
    </ng-template>
    <div class="card-body">
      <app-excessprotect-proposer-details 
        [staticData]="staticData" 
        [apiModelObject]="apiModelObject" 
        [mtaFinancials]="mtaFinancials"
        (modelObjectUpdated)="modelObjectUpdated($event)" 
        [authDetails]="authDetails"
      ></app-excessprotect-proposer-details>
    </div>
  </mat-tab>
    <!-- Vehicles Tab -->
  <mat-tab [disabled]="unlockedTabIndex < 1 || quote_type == 4">
    <ng-template mat-tab-label>
      Vehicles
    </ng-template>
    <div class="card-body">
      <app-excess-protect-vehicles 
        [staticData]="staticData" 
        [excessProtectOptions]="excessProtectOptions"
        [modelObject]="modelObject" 
        (modelObjectUpdated)="modelObjectUpdated($event)"
        (mtaFinancialsUpdated)="onMtaFinancialsUpdated($event)" 
        [apiModelObject]="apiModelObject" 
        [authDetails]="authDetails"
      ></app-excess-protect-vehicles>
    </div>
  </mat-tab>
    <!-- Quotation Tab -->
  <mat-tab [disabled]="unlockedTabIndex < 2 || quote_type == 4">
    <ng-template mat-tab-label>
      Quotation
    </ng-template>
    <div class="card-body">
      <app-excess-protect-quotation 
       (back)="selectedIndex = selectedIndex - 1"
        [staticData]="staticData" 
        [excessProtectOptions]="excessProtectOptions"
        [modelObject]="modelObject" 
        (modelObjectUpdated)="modelObjectUpdated($event)" 
        (mtaFinancialsUpdated)="onMtaFinancialsUpdated($event)"
        [apiModelObject]="apiModelObject" 
      ></app-excess-protect-quotation>
    </div>
  </mat-tab>
</mat-tab-group>
